import React from "react";
import CommonButtons from "../../../../components/CommonButtons";

interface Props {
  onCancel: () => void;
  onUpdate: () => void;
  visible: boolean;
  loading?: boolean;
}

const EditBranchActions: React.FC<Props> = ({ onCancel, onUpdate, visible, loading = false }) => {
   const isDisabled = !visible || loading;
  return (
    <div className="flex justify-end gap-6 mt-2">
      <CommonButtons
        className="w-36 h-10"
        label="Cancel"
        variant="outlineDanger"
        onClick={onCancel}
        disabled={loading}
      />
      <CommonButtons
        className="w-36 h-10"
        label={loading ? "Updating..." : "Update"}
        onClick={!isDisabled ? onUpdate : undefined}
        disabled={isDisabled}
      />
    </div>
  );
};

export default EditBranchActions;
